import { render, staticRenderFns } from "./ServicerHelpList.vue?vue&type=template&id=541adf44&"
import script from "./ServicerHelpList.vue?vue&type=script&lang=js&"
export * from "./ServicerHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports